/* eslint-disable */
import Layout from '@/layout/index.vue';

const routes = {
  // 主页
  Content: () => import(/* webpackChunkName: "dict" */ '@/views/page/Content/index')
};

export const contentRoute = [
  {
    path: '/Content',
    isMenu: true,
    component: Layout,
    redirect: { name: 'Content' },
    children: [
      {
        path: 'index',
        name: 'Content',
        component: routes['Content'],
        meta: { title: '官网内容管理', icon: 'menu_guanwanguanli'}
      }
    ]
  }
];
